import React from "react";

const formatPeriodDisplay = (period) => {
	if (!period) return null;
	if (typeof period === "string") return period;
	return period.displayLabel || period.label || null;
};

const AdminDashboardHeader = ({
	title = "Admin Dashboard",
	currentPeriod,
	previousPeriod,
	comparisonMode,
	loadedCount,
	totalCount,
	sortBy,
}) => {
	const currentLabel = formatPeriodDisplay(currentPeriod);
	const previousLabel = formatPeriodDisplay(previousPeriod);
	const dayCount = currentPeriod?.dayCount;
	const showProgress =
		typeof loadedCount === "number" &&
		typeof totalCount === "number" &&
		totalCount > 0;

	const comparisonHint =
		comparisonMode === "selectedMonthRange" && dayCount != null
			? `Selected range vs same days in previous month (${dayCount} day${dayCount === 1 ? "" : "s"})`
			: comparisonMode === "rolling30Day"
				? "Comparing last 30 days vs prior 30 days"
				: comparisonMode === "sameDayRange" && dayCount != null
					? `Comparing ${dayCount} day${dayCount === 1 ? "" : "s"} in each period`
					: null;

	return (
		<div>
			<h2>{title}</h2>
				{currentLabel && previousLabel && (
					<div className="periodBadgeGroup">
						<span className="periodBadge">
							{currentLabel} vs {previousLabel}
						</span>
						{comparisonHint && (
							<span className="periodBadgeSubtext">{comparisonHint}</span>
						)}
						{sortBy === "totalSearchesDesc" && (
							<span className="periodBadgeSubtext">
								Sorted by highest searches
							</span>
						)}
						{sortBy === "questionsDesc" && (
							<span className="periodBadgeSubtext">
								Sorted by highest questions
							</span>
						)}
						{showProgress && (
							<span className="periodBadgeSubtext">
								Loaded {loadedCount} of {totalCount} websites
							</span>
						)}
					</div>
				)}
		</div>
	);
};

export default AdminDashboardHeader;
